import { createAction, props } from '@ngrx/store';
import { ResponseRendicontazioni } from '../../interfaces/response-rendicontazione';
import { IRendicontazioniState } from './rendicontazione';

export const RETRIEVE_RENDICONTAZIONI = createAction(
  '[RENDICONTAZIONI] - retrieve rendicontazioni'
);

export const RETRIEVE_RENDICONTAZIONI_SUCCESS = createAction(
  '[RENDICONTAZIONI] - retrieve rendicontazioni success',
  props<{ rendicontazioni: ResponseRendicontazioni | null }>()
);

export const DOWNLOAD_RENDICONTAZIONE = createAction(
  '[RENDICONTAZIONI] - download rendicontazione',
  props<{ payload: string }>()
);

export const RESET_RENDICONTAZIONE_STORE = createAction(
  '[RENDICONTAZIONI] - reset rendicontazione store'
)
